/**
 * VSUS-1338: o backend devolve 401 tanto para token inválido quanto para
 * falta de permissão. O interceptor só deve encerrar a sessão quando o
 * refresh não existia ou falhou de verdade.
 *
 * Refresh ok + retry ainda 401 = autorização, sessão intacta.
 */
export function shouldLogoutOn401({
  hadRefreshCookie = false,
  refreshSucceeded = false,
} = {}) {
  if (hadRefreshCookie && refreshSucceeded) {
    return false;
  }

  return true;
}
